// duckling is short for reduckling, which is a baby redux.

import React from "react";

export let voterNameReducer = (state, action) => {
  switch (action.type) {
    case "SET_NAME":
      let name = action.payload;
      window.localStorage.setItem("voter", name);
      return name;
    case "CLEAR":
      return "";
    case "INIT":
      let storedName = window.localStorage.getItem("voter");
      return storedName ? storedName : "";
    default:
      return state;
  }
};

export let VoterNameContext = React.createContext({
  voter: "",
  dispatch: null,
});
